import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
    from { opacity: 0; transform: translateX(8px); }
    to   { opacity: 1; transform: translateX(0); }
`;

export const StyledExposureRoot = styled.div<{ $visible: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
    transition: opacity 0.2s ease;
    animation: ${({ $visible }) => ($visible ? fadeIn : "none")} 0.2s ease;
`;

export const StyledExposureSliderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background: ${({ theme }) => theme.secondaryBackground}CC;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 20px;
    padding: 10px 8px;
`;

export const StyledExposureSunBtn = styled.button<{ $lit: boolean }>`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    font-size: 18px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s;
    color: ${({ $lit, theme }) =>
        $lit ? theme.colors.yellowAccent : theme.secondaryTypographyColor};

    .anticon {
        font-size: 18px;
    }
`;

export const StyledExposureTrackWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
`;

export const StyledExposureTrackLabel = styled.span`
    font-size: 9px;
    color: ${({ theme }) => theme.disabledTypographyColor};
    line-height: 1;
    user-select: none;
`;

export const StyledExposureSlider = styled.input`
    -webkit-appearance: slider-vertical;
    appearance: slider-vertical;
    writing-mode: vertical-lr;
    direction: rtl;
    width: 28px;
    height: 100px;
    cursor: pointer;
    accent-color: ${({ theme }) => theme.colors.yellowAccent};
    background: transparent;
`;

export const StyledExposureValueBadge = styled.div<{ $nonZero: boolean }>`
    font-size: 11px;
    font-weight: 500;
    min-width: 32px;
    text-align: center;
    opacity: 0.85;
    transition: color 0.15s;
    color: ${({ $nonZero, theme }) =>
        $nonZero ? theme.colors.yellowAccent : theme.secondaryTypographyColor};
`;

export const StyledExposureResetBtn = styled.button<{ $visible: boolean }>`
    background: none;
    border: 1px solid
        ${({ $visible, theme }) =>
            $visible ? `${theme.colors.yellowAccent}66` : "transparent"};
    border-radius: 50%;
    width: 22px;
    height: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin-top: 2px;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
    transition:
        opacity 0.2s ease,
        border-color 0.2s ease,
        color 0.15s;
    color: ${({ theme }) => theme.colors.yellowAccent};

    .anticon {
        font-size: 12px;
    }
`;
